import { Commit, ResizerRegistryItem } from '@/store';
import { StoreMutationType } from '@/types/StoreMutationType';
import { getElementHeight, getElementWidth } from './DOM';

export function updateResizeRegistryItem(name: string, selector: string): void {
  const element = document.getElementById(selector);
  Commit(StoreMutationType.UPDATE_RESIZE_REGISTRY_ITEM, {
    name,
    width: getElementWidth(element),
    height: getElementHeight(element),
  });
}

export function registerResizeItem(item: ResizerRegistryItem): void {
  if (!item) {
    console.error('registerResizeItem: item is required');
    return;
  }

  if (!item.name) {
    console.error('registerResizeItem: name is required');
    return;
  }

  if (!item.selector) {
    console.error('registerResizeItem: selector is required');
    return;
  }

  if (!item.resizeFunc) {
    item.resizeFunc = updateResizeRegistryItem;
  }

  Commit(StoreMutationType.ADD_RESIZE_REGISTRY_ITEM, item);
}
